<form [formGroup]='formGroup'
      class='widget'>
  <div *ngIf='selectMode; else checkBox'>
    <pt-input-label
      *ngIf='label'
      [inputId]='inputId'
      [isRequired]='isRequired'
      [label]='label'
      style='display: contents'
    ></pt-input-label>
    <div
      [class.is-invalid]='formGroup.invalid && formGroup.touched'
      [class.ng-dirty]=formGroup.dirty
      [class.ng-invalid]='formGroup.invalid && formGroup.touched'
      [class.ng-touched]=formGroup.touched
      [class.ng-valid]=formGroup.valid
      class='form-control form-control-sm ng-select-single-control'
    >
      <ng-select
        [clearable]='selectMode.clearable'
        [disabled]='disabled'
        [id]='inputId'
        [placeholder]='selectMode.placeholder | async'
        [searchable]='false'
        appendTo='body'
        bindLabel='label'
        bindValue='value'
        formControlName='value'
      >
        <ng-option *ngFor='let option of options' [value]='option.value'>
          {{ option.label | async }}
        </ng-option>
      </ng-select>
    </div>
    <small [innerHTML]='help'
           *ngIf="help"
           class='form-text text-muted' id='{{inputId}}_help'>
    </small>
  </div>
  <ng-template #checkBox>
    <div class='form-check'>
      <input
        [id]='inputId'
        class='form-check-input'
        formControlName='value'
        type='checkbox'
        value=''
      >
      <label [for]='inputId' class='form-check-label'>
        <div class="d-flex align-items-center">
          {{ label }}
          <pt-icon *ngIf="help" class='pe-1 d-flex' [ngbTooltip]="help" [key]='IconInfo' [size]="18"></pt-icon>
        </div>
      </label>
    </div>
  </ng-template>
</form>

